export default "__VITE_ASSET__DdwNJvBb__"